import { CpPlansProposalPlansInterface } from '../../../../interfaces/dto/client-portal/proposal/proposal-plans-interface';
import { CpPlansInsuredPersonsModel } from '../insured-persons/cp-plans-insured-persons-model';

export class CpPlansProposalPlansModel implements CpPlansProposalPlansInterface {
  id: number | undefined;
  productId: string = '';
  email: string = '';
  name: string = '';
  gender: string = '';
  address: string = '';
  location: string = '';
  postalCode: string = '';
  postalCodePrefix: string = '';
  phone: string = '';
  phoneCode: string = '';
  taxNumber: string = '';
  taxNumberCode: string = '';
  birthDate: string = '';
  subscriberIsBeneficiary: number = 0;
  locale: string = '';
  taxNumberPayment: string = '';
  taxNumberPaymentCode: string = '';
  paymentAccoutOwner: string = '';
  nibPayment: string = '';
  countryPayment: string = '';
  addressPayment: string = '';
  locationPayment: string = '';
  postalCodePayment: string = '';
  refMbAmount: number = 0;
  gift: boolean = false;
  paymentMethod: string = '';
  paymentMethodCode: string = '';
  firstMeanOfPayment: string = '';
  fractioningDescription: string = '';
  fractionatedPaymentCode: string = '';
  totalValue: number = 0;
  contractStartDate: string = '';
  token: string = '';
  finished: boolean = false;
  consents: number[] = [];
  insuredPersons: CpPlansInsuredPersonsModel[] = [];

  constructor(init?: Partial<CpPlansProposalPlansModel>) {
    Object.assign(this, init);
  }
}
